import { useState } from 'react'

interface Props {
  token: string
  /** Önizleme container'ının max yüksekliği (px). Default 320 (eski sidebar boyutu). */
  maxHeightPx?: number
}

// Yayın canvas'ı 16:9 oranında. iframe public overlay URL'sini yükler;
// WS ile state değişince canlı güncellenir (renderer kendi subscribe ediyor).
export default function OverlayPreview({ token, maxHeightPx = 320 }: Props) {
  const [reloadKey, setReloadKey] = useState(0)
  const url = `https://kick.pxlab.dev/o/${token}`

  return (
    <section className="rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)]">
      <header className="flex items-center justify-between px-4 py-2.5 border-b border-[var(--color-border)]">
        <div>
          <h3 className="text-xs font-semibold uppercase tracking-wider text-[var(--color-text-muted)]">
            Canlı önizleme
          </h3>
        </div>
        <button
          onClick={() => setReloadKey((k) => k + 1)}
          title="Yeniden yükle"
          className="p-1.5 rounded text-[var(--color-text-muted)] hover:text-[var(--color-text)] hover:bg-[var(--color-elevated)]"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="23 4 23 10 17 10" />
            <polyline points="1 20 1 14 7 14" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
          </svg>
        </button>
      </header>
      <div className="p-2">
        <div
          className="aspect-video w-full mx-auto rounded overflow-hidden relative border border-[var(--color-border)]"
          style={{
            maxHeight: `${maxHeightPx}px`,
            background: 'repeating-conic-gradient(#1c1d20 0% 25%, #16171a 0% 50%) 0 / 16px 16px',
          }}
        >
          <iframe
            key={reloadKey}
            src={url}
            className="absolute inset-0 w-full h-full border-0"
            sandbox="allow-scripts allow-same-origin"
            title="Overlay önizleme"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  )
}
